function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { Fragment, useContext, useState, useEffect, useRef } from "react";
import { CarinaContext } from "../CarinaProvider";
import useStyle from "./Modal.style";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { renderWithPortal } from "./renderWithPortal";
import { useScrollLock } from "../../hooks/useScrollLock";
import debounce from "lodash/debounce";
import FocusTrap from "focus-trap-react";
import Scrim from "../Scrim";
import { Transition } from "../Transition/Transition";
import { applySpreaderProp } from "../../utils/applySpreaderProp";
import { devMessage } from "../../utils";
import { getScrimZIndex, getZIndex, ZIndexProvider } from "../ZIndexProvider";
import useTransitions from "./hooks/useTransitions";
import useContentDelay from "./hooks/useContentDelay";
import useTransitionDuration from "./hooks/useTransitionDuration";
function handleKeyDown(onDismiss, onKeyDown, disableFocusTrap) {
    return function(event) {
        if ((event === null || event === void 0 ? void 0 : event.key) === 'Escape' && !disableFocusTrap) {
            if (typeof onDismiss === 'function') {
                onDismiss();
            }
        }
        if (typeof onKeyDown === 'function') {
            onKeyDown(event);
        }
    };
}
var checkCanFocusTrap = function() {
    return new Promise(function(resolve) {
        setTimeout(resolve, 100);
    });
};
var Modal = function(_param) {
    var _animationFunction = _param.animationFunction, animationFunction = _animationFunction === void 0 ? 'productive' : _animationFunction, children = _param.children, disableFocusTrap = _param.disableFocusTrap, _focusTrapOptions = _param.focusTrapOptions, focusTrapOptions = _focusTrapOptions === void 0 ? {} : _focusTrapOptions, focusTrapRef = _param.focusTrapRef, format = _param.format, height = _param.height, isOpen = _param.isOpen, isRtl = _param.isRtl, onAnimationOut = _param.onAnimationOut, onDismiss = _param.onDismiss, onKeyDown = _param.onKeyDown, portal = _param.portal, scrollLock = _param.scrollLock, testID = _param.testID, transitionProps = _param.transitionProps, ariaLabel = _param['aria-label'], labelledBy = _param['aria-labelledby'], zIndexIn = _param.zIndex, title = _param.title, propDrop = _objectWithoutProperties(_param, [
        "animationFunction",
        "children",
        "disableFocusTrap",
        "focusTrapOptions",
        "focusTrapRef",
        "format",
        "height",
        "isOpen",
        "isRtl",
        "onAnimationOut",
        "onDismiss",
        "onKeyDown",
        "portal",
        "scrollLock",
        "testID",
        "transitionProps",
        'aria-label',
        'aria-labelledby',
        "zIndex",
        "title"
    ]);
    var outerContainerRef = useRef(null);
    var ref4 = _slicedToArray(useState(isOpen), 2), hasOverlayMounted = ref4[0], setHasOverlayMounted = ref4[1];
    var transitionEasing = animationFunction.concat('.easeOut');
    var duration = useTransitionDuration(animationFunction);
    var ftOptions = _objectSpread({
        checkCanFocusTrap: checkCanFocusTrap,
        escapeDeactivates: false
    }, focusTrapOptions);
    var ref1;
    var ref2 = (ref1 = useContext(CarinaContext)) !== null && ref1 !== void 0 ? ref1 : {
        flags: {
            zIndexUpdates: false
        },
        prefersReducedMotion: false
    }, prefersReducedMotion = ref2.prefersReducedMotion, flags = ref2.flags;
    var zIndexUpdates = flags.zIndexUpdates;
    var kind = format === 'fullscreen' ? format : 'modal';
    var zIndex = zIndexUpdates ? getZIndex(kind) : zIndexIn !== null && zIndexIn !== void 0 ? zIndexIn : 1;
    useEffect(function() {
        if (isOpen) {
            setHasOverlayMounted(true);
            if (!ariaLabel && !labelledBy && !title) {
                devMessage('You did not pass in an `aria-label`, `aria-labelledBy`, nor `title` prop to your Carina Modal. You must pass in at least one otherwise it is an axe failure. For more info: https://dequeuniversity.com/rules/axe/4.6/aria-dialog-name?application=axeAPI');
            }
        }
    }, [
        isOpen
    ]);
    useScrollLock({
        isOpen: isOpen,
        hasOverlayMounted: hasOverlayMounted,
        scrollLock: scrollLock === undefined ? false : scrollLock
    });
    var delay = useContentDelay(animationFunction);
    var ref3 = useStyle({
        format: format,
        height: height,
        isRtl: isRtl,
        zIndex: zIndex
    }), outerContainerStyle = ref3.outerContainerStyle, contentContainerStyle = ref3.contentContainerStyle, scrimStyle = ref3.scrimStyle, wrapperStyle = ref3.wrapperStyle;
    var debouncedOnAnimationOut = debounce(function(e) {
        if (!isOpen && onAnimationOut) {
            onAnimationOut(e);
        }
    }, duration);
    var transitions = useTransitions({
        format: format,
        isRtl: isRtl
    });
    var calculatedTransitionProps = applySpreaderProp(transitionProps, {
        appear: true,
        duration: duration,
        easing: prefersReducedMotion ? 'linear' : transitionEasing,
        in: isOpen,
        transitions: transitions,
        unmountOnExit: true
    });
    var handleScrimClick = function(event) {
        if (event.target === event.currentTarget && onDismiss) {
            onDismiss();
        }
    };
    var _className;
    return renderWithPortal(_jsx(ZIndexProvider, {
        kind: kind,
        children: _jsx(Transition, _objectSpread({}, calculatedTransitionProps, {
            children: function(param) {
                var transitionStyles = param.styles, ref = param.ref;
                return _jsx(FocusTrap, {
                    active: !disableFocusTrap,
                    focusTrapOptions: ftOptions,
                    children: _jsxs("div", {
                        ref: focusTrapRef,
                        css: wrapperStyle,
                        children: [
                            _jsx(Scrim, {
                                css: _objectSpread({}, scrimStyle, transitionStyles, {
                                    transitionProperty: 'opacity'
                                }),
                                onClick: handleScrimClick,
                                ref: ref,
                                testID: "".concat(testID, "-scrim"),
                                zIndex: zIndexUpdates ? getScrimZIndex(zIndex) : zIndex
                            }),
                            _jsx("div", _objectSpread({}, propDrop, injectTestId(testID), {
                                "aria-modal": "true",
                                css: _objectSpread({}, outerContainerStyle, transitionStyles),
                                className: 'focus-visible ' + ((_className = propDrop.className) !== null && _className !== void 0 ? _className : ''),
                                onAnimationEnd: debouncedOnAnimationOut,
                                onKeyDown: handleKeyDown(onDismiss, onKeyDown, !!disableFocusTrap),
                                ref: outerContainerRef,
                                role: "dialog",
                                "aria-label": ariaLabel,
                                "aria-labelledby": labelledBy,
                                title: title,
                                tabIndex: -1,
                                children: _jsx("div", {
                                    css: _objectSpread({}, contentContainerStyle, transitionStyles, {
                                        transitionDelay: delay,
                                        transitionProperty: 'opacity'
                                    }),
                                    children: children
                                })
                            }))
                        ]
                    })
                });
            }
        }))
    }), portal) || _jsx(Fragment, {});
};
export { Modal };
Modal.defaultProps = {
    animationFunction: 'productive',
    disableFocusTrap: false,
    format: 'm',
    onAnimationOut: function() {},
    portal: false,
    scrollLock: true,
    zIndex: 1
};
export default Modal;
